import "./Login.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../../Api/Services";

function Login() {
  const [inputValue, setInputValue] = useState({
    username: "",
    password: "",
  });
  const [flagLoading, setFlagLoading] = useState(false);

  const navigate = useNavigate();

  const LoginCheck = async () => {
    try {
      setFlagLoading(true);
      const UsersTokenRes = await api.UsersToken(inputValue);
      if (UsersTokenRes.data.access_token) {
        const UserDet = await api.UsersGetMyUserByToken();
        if (UserDet.status && UserDet.status === 200) {
          const IdentityUser = await api.FetchMyAccess();
          if (IdentityUser.status && IdentityUser.status === 200) {
            localStorage.setItem(
              "Identity",
              JSON.stringify(IdentityUser.data.data.userClaimValues)
            );
            localStorage.setItem("Username", inputValue.username);
            localStorage.setItem("ExpTime", UserDet.data.data.expDate);
            if (UserDet.data.data.stat == 1) {
              navigate("/Panel/Home");
            } else {
              navigate("/SetCode");
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFlagLoading(false);
    }
  };
  const loginByEnter = (e) => {
    if (e.key === "Enter") {
      LoginCheck();
    }
  };

  return (
    <>
      {flagLoading && (
        <div
          className="scopeLoading d-flex justify-content-center align-items-center"
          style={{ height: window.innerHeight }}
        >
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={flagLoading ? "startLoading" : "stateLoading"}>
        <div className="d-flex justify-content-center align-items-center">
          <div id="loginForm">
            <h2 className="text-center w-100 mt-2">ورود</h2>
            <div className="p-5" onKeyPress={loginByEnter}>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="شماره موبایل"
                  value={inputValue.username}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      username: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center mb-5">
                <input
                  className="loginInput"
                  type="password"
                  placeholder="رمز عبور"
                  value={inputValue.password}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      password: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center">
                <button className="loginButton mt-3" onClick={LoginCheck}>
                  ورود
                </button>
              </div>
              <div
                onClick={() => {
                  navigate("/Register");
                }}
                className="d-flex justify-content-center pt-2"
              >
                <span className="text-info pointer">ثبت نام</span>
              </div>
              <div
                onClick={() => {
                  navigate("/ForgetPass");
                }}
                className="d-flex justify-content-center pt-2"
              >
                <span className="text-info pointer">فراموشی رمز</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
